var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {


















pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};






































pug_html = pug_html + "\u003Ch2\u003EUpdate redemption request\u003C\u002Fh2\u003E\u003Cform layout=\"column\" layout-padding flex name=\"vm.updateForm\" api-form=\"vm.confirmAction()\"\u003E\u003Cdiv class=\"redemption-request-info-container\" layout=\"row\" layout-align=\"space-between start\"\u003E\u003Cdiv class=\"redemption-request-info date\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003ERequest date\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.date | date: 'd MMM yyyy' }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info category\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003ERequest category\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.category }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info type\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003ERequest type\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.type }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info kind\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003ERequest kind\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.kind }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info-container\" layout=\"row\" layout-align=\"space-between start\"\u003E\u003Cdiv class=\"redemption-request-info investment-start-date\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003EInvestment start date\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.investmentProductPartSummary.startDate | date: 'd MMM yyyy' }} ({{ vm.investmentProductRedemptionRequest.investmentProductPartSummary.startDate | asDiff }}d)\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info investment-end-date\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003EInvestment end date\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.investmentProductPartSummary.endDate | date: 'd MMM yyyy' }} ({{ vm.investmentProductRedemptionRequest.investmentProductPartSummary.endDate | asDiff }}d)\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info user\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003EInvestor\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.userSummary | asUserFullName }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"redemption-request-info investment-current-value\" layout=\"column\" flex=\"25\"\u003E\u003Clabel\u003EInvestment value\u003C\u002Flabel\u003E\u003Cvalue\u003E{{ vm.investmentProductRedemptionRequest.valueAtRequestDate | asCurrency:4 }}\u003C\u002Fvalue\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput-container label=\"Redemption amount\"\u003E\u003Cinput ng-disabled=\"vm.investmentProductRedemptionRequest.category === &quot;maturity&quot; || vm.investmentProductRedemptionRequest.category === &quot;involuntary&quot;\" type=\"text\" required name=\"amount\" ng-model=\"vm.amount\" fraction=\"4\" ng-currency step=\"0.0001\"\u003E\u003Cng-message when=\"pattern\"\u003EEnter amount in dollars and cents\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Redemption fee\"\u003E\u003Cinput type=\"text\" required name=\"fee\" ng-model=\"vm.fee\" fraction=\"4\" ng-currency step=\"0.0001\"\u003E\u003Cng-message when=\"pattern\"\u003EEnter fee in dollars and cents\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cbr\u003E\u003Cdiv class=\"actions\" layout=\"row\"\u003E\u003Cmd-button class=\"md-raised md-primary approve\" type=\"submit\"\u003EApprove!\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised cancel\" type=\"button\" ng-click=\"vm.cancelAction()\"\u003ECancel\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;